import React, { useCallback, useEffect, useRef, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "./Support.css";
import { GenericTable } from "../../components/genericTable/GenericTable";
import {
  GridColDef,
  GridColumnHeaderParams,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { Loader } from "../../components/loader/Loader";
import { NewSupportConfiguartion, SupportConfiguartion } from "./SupportConfiguration";
import {
  divisionMetaData,
  reportType,
  searchPropsType,
  supportType,
} from "./SupportTypes";
import { Stack, TextField, Tooltip } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { popupType } from "../../types/types";
import { GenericPopUp } from "../../components/popup/genericPopUp";
import {
  downloadSupportReport,
  getReports,
  getReportsSearchData,
  getReportsSearchDataNew,
  getReportStatus,
  uploadReport,
} from "../../services/supportService";
import { getDivision } from "../../services/userService";
import { Modal } from "@mui/material";

import SupportModal from "./SupportModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import DownloadLoader from "../../components/popup/downloadLoader";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { getAccessToken, getLob } from "../../services/authenticationService";
import { fetchAndDownloadReport } from "../../services/reportService";
import BackButton from "../../components/Buttons/BackButton/BackButton";
import { ChannelkartNetworkGet } from "../../services/networkService";
import { isGapMoreThanNDays } from "../../utils/calenderUtils";
import { getMetaDataConfig } from "../../services/uiConfigService";
import { configurationAttributeType } from "../../types";

const Support = () => {
  const { translate } = usePortalTranslation();
  const [allRows, setAllRows] = useState<reportType[]>();
  const [openModal, toggleModal] = useState(false);
  const [modelData, setModelData] = useState<supportType>();
  const [divison, setDivison] = useState();

  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

  const [confirmationPopUp, setConfirmationPopUp] = useState(false);
  const [loader, setLoader] = useState(true);

  const [popUpMessage, setPopUpMessage] = useState<string>("");

  const popUpSuccessMethod = useRef<any>();

  const [startDate, setStartDate] = useState<Dayjs>(dayjs());

  const [endDate, setEndDate] = useState<Dayjs>(dayjs());

  const [reportDownloadInProcess, setReportDownloadInProcess] = useState(false);

  const [openReportModel, setOpenReportModal] = useState(false);

  const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);

  const searchedText = useRef<string>("");
  const token = getAccessToken()
  const [newSupport, setNewSupport] = useState<boolean>(false);
  const [columnConfig, setColumnConfig] = useState<any>(SupportConfiguartion);

  const columns: GridColDef[] = columnConfig.columns.map(
    (columnsMetaData:any) => {
      return {
        disableColumnMenu: true,
        field: columnsMetaData.mappedValue,
        headerName: columnsMetaData.headerName,
        sortable: false,
        minWidth: 100,
        flex: 1,
        headerAlign: "left",
        align: "left",
        renderHeader: (params: GridColumnHeaderParams) => (
          <Tooltip title={translate(TranslationEnum.support,columnsMetaData.headerName)}>
            <b>{translate(TranslationEnum.support,columnsMetaData.headerName)}</b>
          </Tooltip>
        ),
        valueGetter: (params: GridRenderCellParams) => {
          const field = params.field;
          let finalData: any;
          if (field.includes(".")) {
            const filedArrays = field.split(".");
            finalData = params.row;
            filedArrays.forEach((s: string) => {
              if (!finalData) {
                return;
              }
              finalData = finalData[s];
            });
            return finalData;
          }

          return params.row[field];
        },
      };
    }
  );

  const createToolTip = (title: string) => {
    return (
      <Tooltip title={title}>
        <b>{translate(TranslationEnum.support,title)}</b>
      </Tooltip>
    );
  };

  const setImageToDataGrid = (params: GridRenderCellParams) => {
    const headers = {} as { [key: string]: string};
    const blobKey = newSupport ? params.row.blobKey : params.row.blob_key;
    const url = `${blobKey}`;
    if(url.includes("salescode.ai") || url.includes("sellina.io") || url.includes("sellinademo.io")){
      headers['Authorization'] = `Bearer ${token}`;
      headers['lob'] = getLob()
    }
    const handleDownload = () => {
      fetch(url,{ 
        headers
      })
        .then(response => response.blob())
        .then(blob => {
          const blobUrl = URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = blobUrl;
          anchor.download = 'image.jpg';
          anchor.click();
          URL.revokeObjectURL(blobUrl);
        })
        .catch(error => {
          console.error('Error downloading image:', error);
          openPopUp("Something went wrong while downloading the file","Error");
        });
    };
    // const handleDownload = async () => {
    //   try {
    //     const url = `${params.row.blob_key}`;
    //     const response = await ChannelkartNetworkGet(url);
    
    //     // Convert the response to a Blob
    //     const blob = new Blob([response.data], { type: response.headers['content-type'] });
    
    //     // Create a Blob URL and trigger download
    //     const blobUrl = URL.createObjectURL(blob);
    //     const anchor = document.createElement('a');
    //     anchor.href = blobUrl;
    //     anchor.download = 'image.jpg'; // You can customize the filename if needed
    //     anchor.click();
    //     URL.revokeObjectURL(blobUrl); // Cleanup
    
    //   } catch (error) {
    //     console.error('Error downloading image:', error);
    //     openPopUp("Something went wrong while downloading the file", "Error");
    //   }
    // };
    return blobKey ? (
      <button
        className="support-asignee-button"
        onClick={handleDownload}
      >
        Download
      </button>
    ) : (
      <p>{translate(TranslationEnum.support,"No Image")}</p>
    );
  };


  const getSearchedData = async (searchValue: string) => {
    try {
      const response = newSupport ? await getReportsSearchDataNew(searchValue) : await getReportsSearchData(searchValue);
      const rowsData = manipulateRowData(response.data.features);
      setAllRows(rowsData);
      setLoader(false);
    } catch (error) {
      openPopUp("Something Went Wrong", "Error");
      setAllRows([]);
      setLoader(false);
    }
  };

  const debouncingTheSearch = useCallback(
    (value: string) => {
      // debouncing code
      if (timerId) {
        clearTimeout(timerId);
      }
      const newTimerId = setTimeout(() => {
        setLoader(true);
        value === ""
          ? getReportMetaData(startDate, endDate)
          : getSearchedData(value);
      }, 400); // debounce time in milliseconds
      setTimerId(newTimerId);
    },
    [timerId, searchedText]
  );

  const setAssignee = (params: GridRenderCellParams) => {
    return (
      <button
        className="support-asignee-button"
        onClick={() => {
          setModelData(params.row);
          toggleModal(true);
        }}
      >
        {translate(TranslationEnum.support,"Assign")}
      </button>
    );
  };

  const addActionAttributes = (
    field: string,
    headerName: string,
    action: (params: GridRenderCellParams) => JSX.Element
  ) => {
    columns.push({
      field,
      headerName,
      sortable: false,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderHeader: (params: GridColumnHeaderParams) => {
        return createToolTip(field);
      },
      renderCell: action,
    });
  };

  const Actions = columnConfig.Actions;
  Actions.forEach((columnName:any) => {
    switch (columnName) {
      case "Image":
        addActionAttributes(columnName, columnName, setImageToDataGrid);
        break;

      case "Assign":
        addActionAttributes(columnName, columnName, setAssignee);
        break;
    }
  });

  const searchProps: searchPropsType[] = columnConfig.columns.map(
    (data: any) => {
      return {
        searchKey: data.mappedValue,
        searchFilter: (a: string, b: string) => {
          return a === b;
        },
      };
    }
  );


  const manipulateRowData = (reportMetaData: supportType[]) => {
    const extendedData = reportMetaData.map(
      (eachRow: supportType, idx: number) => {
        if (eachRow.extended_attributes) {
          const extraData = JSON.parse(eachRow.extended_attributes);
          return { ...eachRow, ...extraData };
        } else if (eachRow.extendedAttributes) {
          const extraData = eachRow.extendedAttributes;
          return { ...eachRow, ...extraData };
        } else {
          return { ...eachRow };
        }
      }
    );
    return extendedData;
  };
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const validDateRange = ConfigDictionary.dateRangeConfig ?? 31;
  const canWeMakeRequest = () => {
    if (startDate && endDate && isGapMoreThanNDays(startDate, endDate, validDateRange)) {
      openPopUp(`You can't select date range more than ${validDateRange} days!`, "Alert");
      return false;
    }
    if (
      startDate &&
      endDate &&
      isStartDateIsGreaterThanEndDate(startDate, endDate)
    ) {
      openPopUp("To Date should be greater than from date.", "Alert");
      return false;
    }
    return true;
  };

  const getReportMetaData = async (
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs,
    newSupportConfig?:boolean
  ) => {
    try {
      if (canWeMakeRequest()) {
        setLoader(true);
        const from = startDate
          .toISOString()
          .substring(0, 10)
          .concat(" 00:00:00");
        const to = endDate.toISOString().substring(0, 10).concat(" 23:59:59");
        const response = await getReports(from, to, newSupportConfig ?? newSupport);
        const rowsData = manipulateRowData(response.data.features);
        setAllRows(rowsData);
        searchedText.current = "";
      }
      setLoader(false);
    } catch (error) {
      openPopUp("Something Went Wrong", "Error");
      setAllRows([]);
      setLoader(false);
    }
  };

  const isStartDateIsGreaterThanEndDate = (
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs
  ) => {
    const diff = endDate.diff(startDate);
    return diff < 0;
  };

  const getAllDivision = async () => {
    const response = await getDivision();
    let allDivisions = response.map((division: divisionMetaData) => {
      return division.divisionName;
    });
    allDivisions = allDivisions.filter((divison: string, index: number) => {
      return allDivisions.indexOf(divison) === index;
    });
    setDivison(allDivisions);
  };
  const fetchPortalConfig = async () => {
    setLoader(true);
    const portalConfig = await getMetaDataConfig(
      "clientConfig",
      "portal_configuration"
    );
    const portal_config: configurationAttributeType[] =
      portalConfig?.domainValues ?? [];

    const supportConfig = portal_config?.find(
      (item) => item.name === "newSupport"
    )?.value ?? false;
    setColumnConfig(supportConfig ? NewSupportConfiguartion : SupportConfiguartion)
    setNewSupport(supportConfig);
    setLoader(false);
    return supportConfig;
  };

  const createRequestBodyForReport:any = () => {
    const from = startDate.toISOString().substring(0, 10).concat(" 00:00:00");
    const to = endDate.toISOString().substring(0, 10).concat(" 23:59:59");
    const requestBody = {
      attributes: {
        name: "HelpdeskReportExcel",
        format: "xlsx",
        fromDate: from,
        toDate: to,
      },
      lob: JSON.parse(localStorage.authContext).user.lob,
    };
    const dataObj = JSON.stringify(requestBody);
    
    generateReport(dataObj);
  };

  const openPopUp = (message: string, modalType: popupType) => {
    setGenericModalSMessage(message);
    setGenericModalState(true);
    setGenericModalType(modalType);
  };

  const generateReport = async (obj: string) => {
    const requestBody = JSON.parse(obj);
    if (reportDownloadInProcess) {
      openPopUp("Report downloading already in progress,please wait.", "Alert");
      return;
    }
    setReportDownloadInProcess(true);
    setOpenReportModal(true);
    const response = await uploadReport(requestBody);
    
    checkReportStatus(response.data.id);
  };

  const checkReportStatus = async (id: string) => {
    
    const response = await getReportStatus(id);
    if (response.status === 200 && response.data.features.length > 0) {
      const reportMetaData = response.data.features[0];
      const status = reportMetaData.status;
      if (status === "SUCCESS" || status === "FAILURE") {
        await downloadReport(id);
        setReportDownloadInProcess(false);
        if (status === "FAILURE") {
          setOpenReportModal(false);
          openPopUp("Something Went Wrong", "Error");
        }
      } else {
        setTimeout(() => {
          checkReportStatus(id);
        }, 10000);
      }
    } else {
      openPopUp(
        "Looks like master data report has not been generated yet",
        "Alert"
      );
    }
  };

  const downloadReport = async (id: string) => {
    try {
      
      const response = await downloadSupportReport(id);
      if (response.status === 200) {
        const disposition = response.headers["content-disposition"];

        let filename = "";
        if (disposition && disposition.indexOf("attachment") !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          }) as Blob;
          const URL = window.URL || window.webkitURL;
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          if (typeof a.download === "undefined") {
            openPopUp("Error while downloading file", "Alert");
          } else {
            a.href = downloadUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        } else if (
          disposition &&
          disposition.indexOf("File is too big to download") !== -1
        ) {
          openPopUp("Error while downloading file", "Alert");
        } else {
          openPopUp("Error while downloading file", "Alert");
        }
      } else {
        openPopUp("Error while downloading file", "Alert");
      }

      setReportDownloadInProcess(false);
      setOpenReportModal(false);
    } catch (error) {
      openPopUp("Error while downloading file", "Alert");
      setReportDownloadInProcess(false);
      setOpenReportModal(false);
    }
  };

  const updateConfirmationPopData = (message: string, methodHelper: any) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };

  const fetchAllRequiredData = async () => {
    const newSupportConfig = await fetchPortalConfig();
    await getReportMetaData(startDate, endDate,newSupportConfig);
    await getAllDivision();
  };

  useEffect(() => {
    fetchAllRequiredData();
  }, []);

  return (
    <>
      <div className="support-helpdesk">
        <div className="support-heading">
          <div className="support-label">
            <span>{translate(TranslationEnum.support,"HELPDESK")}</span>
          </div>
          <BackButton />
        </div>
        <div className="support-utility-options">
          <div className="support-utility-dates">
            <Stack spacing={2.8} direction={"row"}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={translate(TranslationEnum.common_portal,"From Date")}
                  inputFormat="DD-MM-YYYY"
                  value={startDate}
                  maxDate={dayjs()}
                  onChange={(value) => {
                    if (value) {
                      setStartDate(value);
                    }
                  }}
                  renderInput={(props) => (
                    <TextField {...props} disabled size="small" />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={translate(TranslationEnum.common_portal,"To Date")}
                  inputFormat="DD-MM-YYYY"
                  value={endDate}
                  maxDate={dayjs()}
                  onChange={(value) => {
                    if (value) {
                      setEndDate(value);
                    }
                  }}
                  renderInput={(props) => (
                    <TextField {...props} disabled size="small" />
                  )}
                />
              </LocalizationProvider>
            </Stack>
            <div>
              <button
                className="support-apply-button"
                onClick={() => {
                  getReportMetaData(startDate, endDate);
                }}
              >
              {translate(TranslationEnum.common_portal,"APPLY")}
              </button>
            </div>
          </div>
          <div className="support-utility-buttons">
            <div className="support-utility-search">
              <TextField
                id="outlined-basic"
                label={translate(TranslationEnum.common_portal,"Search")}
                variant="outlined"
                size="small"
                autoComplete="off"
                onChange={(e) => {
                  const value = e.target.value;
                  if (!value.includes("\\") && !value.includes("`")) {
                    searchedText.current = e.target.value;
                    debouncingTheSearch(e.target.value);
                  }
                }}
                value={searchedText.current}
              />
            </div>
            <FontAwesomeIcon
              className="support-lable-export"
              icon={faFileExcel}
              onClick={() => {
                if (canWeMakeRequest()) {
                  setConfirmationPopUp(true);
                  updateConfirmationPopData(
                    "Are you sure want to export the report?",
                    createRequestBodyForReport
                  );
                }
              }}
            />
          </div>
        </div>
        {loader ? (
          <Loader />
        ) : (
          <div className="support-table">
            <GenericTable
              table={{
                columns,
                rows: allRows ? allRows : {},
                isOfflineSearchEnable: false,
                headerClassName: "bold-header",
              }}
              searchedProps={searchProps}
            />
          </div>
        )}
        <GenericPopUp
          type={genericModaltype}
          message={genericModalMessage}
          openGenericModal={genericModalState}
          setOpenGenericModal={() => {
            if (genericModaltype === "Success") {
              searchedText.current !== ""
                ? getSearchedData(searchedText.current)
                : getReportMetaData(startDate, endDate);
            }
            setGenericModalState(false);
          }}
        />
        <ConfirmationPopUp
          openConfirmModal={confirmationPopUp}
          message={popUpMessage}
          setOpenConfirmModal={() => {
            setConfirmationPopUp(false);
          }}
          successMethod={popUpSuccessMethod.current}
        />
      </div>
      <Modal
        open={openModal}
        onClose={() => {
          toggleModal(false);
        }}
      >
        <SupportModal
          close={() => toggleModal(false)}
          modelData={modelData as supportType}
          divison={divison}
          genricModalData={openPopUp}
          canWeMakeRequest={canWeMakeRequest}
        />
      </Modal>

      {openReportModel ? (
        <DownloadLoader
          message={"Your report will be downloaded shortly."}
          openReportModal={openReportModel}
          setOpenReportModal={setOpenReportModal}
        />
      ) : null}
    </>
  );
};

export default Support;
